import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '@oel/js-configuration';

@Pipe({
  name: 'cheminAbsoluStatique',
  standalone: false
})
export class CheminAbsoluStatiquePipe implements PipeTransform {
  private readonly CLE_CONFIG_STATIC_SPA_URL = 'oel-static-spa-url';

  transform(cheminRelatif: string): any {
    return this.obtenirUrlAbsolu(cheminRelatif) || cheminRelatif;
  }

  private obtenirUrlAbsolu(cheminRelatif: string): string {
    const urlBaseSpaStatique = ConfigurationService.getConfig(this.CLE_CONFIG_STATIC_SPA_URL);
    if (urlBaseSpaStatique) {
      const urlBaseNormalise = `${urlBaseSpaStatique}${!urlBaseSpaStatique.endsWith('/') ? '/' : ''}`;
      return new URL(cheminRelatif, urlBaseNormalise).href;
    }

    return null;
  }
}
